import { supabase } from '../lib/supabase';

export interface Profile {
  user_id: string;
  display_name: string | null;
  default_stake: number | null;
  commission_rate: number | null;
  currency: string;
  notifications_enabled: boolean;
  device_alerts_enabled?: boolean;
  avatar: string | null;
  stripe_customer_id?: string | null;
  stripe_subscription_id?: string | null;
  subscription_status?: string | null;
  subscription_current_period_end?: string | null;
  subscription_cancel_at_period_end?: boolean;
  created_at: string;
  updated_at: string;
}

export interface ProfileUpdate {
  display_name?: string | null;
  default_stake?: number | null;
  commission_rate?: number | null;
  currency?: string;
  notifications_enabled?: boolean;
  device_alerts_enabled?: boolean;
  avatar?: string | null;
}

/**
 * Fetch user profile from database
 */
export async function fetchProfile(userId: string): Promise<Profile | null> {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('user_id', userId)
      .single();

    if (error) {
      // If no profile exists, return null (not an error)
      if (error.code === 'PGRST116') {
        return null;
      }
      console.error('Error fetching profile:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Failed to fetch profile:', error);
    throw error;
  }
}

/**
 * Save or update user profile in database
 */
export async function saveProfile(userId: string, profileData: ProfileUpdate): Promise<Profile> {
  try {
    // Use upsert to create or update the profile
    const { data, error } = await supabase
      .from('profiles')
      .upsert({
        user_id: userId,
        ...profileData,
        updated_at: new Date().toISOString(),
      })
      .select()
      .single();

    if (error) {
      console.error('Error saving profile:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Failed to save profile:', error);
    throw error;
  }
}

